export default __webpack_public_path__ + "static/media/error-page-bottom-bg.dbbc9790.svg";